import { OnsiteComment } from './OnsiteComment.js';

export function OnsiteVisit(logbookNote, warningLevels) {
    'use strict';

    var self = this;
    this.logId = logbookNote.logId;
    this.noteId = logbookNote.id;
    this.created = logbookNote.created;
    this.updated = logbookNote.updated;
    this.comments = [];
    this.timeIn = null;
    this.timeOut = null;
    this.siteCode = null;
    this.siteName = null;
    this.userName = null;
    this.phoneNumber = null;
    this.noteHref = logbookNote._links.self.href;
    this.gotoUrl = "/note-detail?note=" + encodeURI(this.noteHref);
    this.duration = 0;
    this.durationDays = 0;
    this.durationHours = 0;
    this.durationMinutes = 0;
    this.showUndoButton = this.created >= moment().startOf('day').toDate();
    this.warningLevel = 0;

    function lowerFieldName(field) {
        return field.charAt(0).toLowerCase() + field.slice(1);
    }

    logbookNote.templateValues.forEach(function (value) {
        var templateSegName = lowerFieldName(value.templateSegmentName);
        self[templateSegName] = (templateSegName === "timeIn" || templateSegName === "timeOut")
            ? moment(value.value).toDate()
            : value.value;
    });

    this.comments = logbookNote.noteComments.map(function (lbComment) {
        lbComment.templateValues = logbookNote.templateValues;
        return new OnsiteComment(lbComment);
    });

    (function (warn) {
        self.duration = (self.timeOut || new Date()).getTime() - self.timeIn.getTime();

        var totalHours = (self.duration / 1000 / 60 / 60);

        self.durationDays = Math.floor(totalHours / 24);
        self.durationHours = Math.floor(totalHours - (self.durationDays * 24));
        self.durationMinutes = Math.floor((self.duration / 1000 / 60) - ((self.durationHours * 60) + (self.durationDays * 24 * 60)));

        if(warn) {
            self.warningLevel = (totalHours >= warn.levelTwo)
                ? 2
                : (totalHours >= warn.levelOne)
                    ? 1
                    : 0;
        }
    })(warningLevels);
}



